import React from "react";
import fetch from "unfetch";
import { List, Divider, Icon } from "antd";
import moment from "moment";

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logs: [],
    };
  }

  componentDidMount() {
    fetch("/api/user/logs", {
      credentials: "include",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": localStorage.getItem("x-access-token"),
      },
    })
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          logs: data,
        });
      });
  }

  render() {
    return (
      <React.Fragment>
        <h5>Historique</h5>
        <p>Ensemble des actions des utilisateurs</p>
        <Divider />
        <List
          itemLayout="horizontal"
          dataSource={this.state.logs}
          renderItem={(log) => (
            <List.Item>
              <List.Item.Meta
                avatar={
                  <div className="log-icon">
                    <Icon
                      type={log.icon}
                      style={{ fontSize: 26, color: "#fff" }}
                    />
                  </div>
                }
                title={<div>{log.action}</div>}
                description={
                  <div>
                    Par {log.actionBy ? log.actionBy.firstname : "-"}{" "}
                    {log.actionBy ? log.actionBy.lastname : "-"} le{" "}
                    {moment(log.actionAt).format("DD MMMM YYYY à HH:mm")}
                  </div>
                }
              />
            </List.Item>
          )}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./components/logs.js